export const systemFontList = ['Arial']
